export default function Ropa() {
  return (
    <div style={{ padding: "1.5rem", maxWidth: "900px" }}>
      <h1>Record of Processing Activities (ROPA) - Pilot (Draft)</h1>

      <h2>Plain language summary</h2>
      <p>
        This document lists what data the pilot uses, why it is used, who can access it, and how
        long it is kept. It is a lightweight pilot record for school review.
      </p>

      <h2>1. Data controller and processor</h2>
      <ul>
        <li>Controller: Netherthorpe School (Ghamilton@netherthorpe-mlt.co.uk)</li>
        <li>Processor: Gregory Hamilton (Ghamilton@netherthorpe-mlt.co.uk)</li>
      </ul>

      <h2>2. Purpose of processing</h2>
      <ul>
        <li>Classroom management (seating plans, behaviour, attendance)</li>
        <li>Teaching support (learning objectives)</li>
        <li>Analytics and reporting during pilot</li>
        <li>Feedback and support</li>
      </ul>

      <h2>2.1 Lawful basis</h2>
      <ul>
        <li>Primary: public task (the school's educational function)</li>
        <li>
          Where applicable: legal obligation, contract, vital interests, legitimate interests, or
          consent, as set out in the trust policy
        </li>
      </ul>

      <h2>3. Categories of data subjects</h2>
      <ul>
        <li>Students</li>
        <li>Teachers / staff users</li>
      </ul>

      <h2>4. Categories of personal data</h2>
      <ul>
        <li>Staff: name, email, role</li>
        <li>Students: name, seating assignment, behaviour/objective records, attendance, SEN status/detail, pupil premium indicator</li>
        <li>Operational data: class names, layouts, event timestamps</li>
        <li>Feedback data: optional contact email, free-text feedback</li>
        <li>Usage analytics: page views and feature usage events</li>
      </ul>

      <h2>5. Special category data</h2>
      <p>SEN status/detail may be processed where provided, solely to support teaching and learning.</p>
      <p>
        Processing relies on an appropriate condition under data protection law as set out in the
        trust policy (for example, substantial public interest in education, vital interests, or
        other applicable conditions).
      </p>
      <p>Do not store medical or safeguarding detail beyond what is required for classroom support.</p>

      <h2>6. Recipients / access</h2>
      <ul>
        <li>Teachers: access to their own classes only</li>
        <li>Admins: access to admin views (feedback, usage analytics)</li>
        <li>Processors: Firebase/Google Cloud for storage; Azure Static Web Apps for hosting</li>
        <li>Future/optional: MIS integration (e.g., Arbor) would be assessed and documented before use</li>
      </ul>

      <h2>7. Retention</h2>
      <p>See Data Retention Policy (pilot defaults).</p>

      <h2>8. Security measures</h2>
      <ul>
        <li>Firebase Authentication for access control</li>
        <li>Firestore security rules (least privilege)</li>
        <li>Admin role checks for admin views</li>
        <li>HTTPS for all traffic</li>
      </ul>

      <h2>9. Data transfers</h2>
      <p>Data hosted in Firebase (region: europe-west2).</p>

      <h2>10. Data subject rights process</h2>
      <p>Requests handled by school contact (Ghamilton@netherthorpe-mlt.co.uk).</p>
      <p>Target response time: within 30 days unless extended under school policy.</p>
      <p>SAR requests are logged in the SAR Log (admin-only) to track status and due dates.</p>

      <p style={{ marginTop: "1.5rem", fontStyle: "italic" }}>
        Disclaimer: This draft is not legal advice and should be reviewed by the school's data
        protection lead.
      </p>
    </div>
  );
}
